import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupSendMsgMemberContentProps } from './msg-group-send-msg-member-content';
import { MsgGroupSendMsgMemberContent } from './msg-group-send-msg-member-content';

export interface MsgGroupSendMsgMemberProps extends MsgGroupSendMsgMemberContentProps {}

export const MsgGroupSendMsgMember = memo(function MsgGroupSendMsgMember({
  message,
}: MsgGroupSendMsgMemberProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupSendMsgMemberContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
